import React from 'react'

const ArrowUp = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="19" height="19" x="0" y="0" viewBox="0 0 64 64" ><g><path d="m61.18 49.08-28-36a1.55 1.55 0 0 0-2.36 0l-28 36a1.49 1.49 0 0 0-.17 1.58A1.51 1.51 0 0 0 4 51.5h56a1.51 1.51 0 0 0 1.35-.84 1.49 1.49 0 0 0-.17-1.58z" fill="#000000" ></path></g></svg>
    )
}

export default ArrowUp